import {makeAutoObservable} from "mobx";
import {api, catchApi} from "../../api";
import {PrinterProjectionDto} from "../../api/sls";

export interface SlsPrinterItem {
    label: string
    id: string
}

class SlsPrinterStore {
    get options(): SlsPrinterItem[] {
        return this._options;
    }

    private set options(value: SlsPrinterItem[]) {
        this._options = value;
    }

    get loaded(): PrinterProjectionDto[] {
        return this._loaded;
    }

    set loaded(value: PrinterProjectionDto[]) {
        this._loaded = value;
    }

    get data(): PrinterProjectionDto[] {
        return this._data;
    }

    set data(value: PrinterProjectionDto[]) {
        this._data = value;
        this.options = this.buildOptions(value)
    }

    private _data: PrinterProjectionDto[] = [];
    private _loaded: PrinterProjectionDto[] = [];
    private _options: SlsPrinterItem[] = []

    constructor() {
        makeAutoObservable(this)
    }

    async load() {
        const result = await catchApi(async () => await api.sls.api.findZebraPrinters())
        this.data = result?.data || []
        this.loaded = this.data
    }

    async find(query?: string) {
        if (!query) {
            return this.load()
        }
        const result = await catchApi(async () => await api.sls.api.findZebraPrinters({
            query
        }))
        this.data = result?.data || []
    }

    reset() {
        this.data = this.loaded
    }

    private buildOptions(data: PrinterProjectionDto[]): SlsPrinterItem[] {
        return data.map(e => ({
            label: `${e.displayName} (${e.name})`,
            id: e.printerId
        }))
    }
}

const slsPrinterStore = new SlsPrinterStore()

export {
    slsPrinterStore
}
